<template>
  <div class="user__global__alert global__alert">
    <b-modal v-model="confirmDeleteAlert" type="warn" title="Confirm Deletion" @ok="deleteAlert(deleteAlertId)" ok-title="Yes, Delete">
        <p>Are you sure you want to delete this alert?</p>
    </b-modal>
    <b-modal
      size="lg"
      hide-footer
      id="userGlobalAlertDetail"
      class="modal-global-alert-detail"
    >
      <template slot='modal-title'>
        {{alertTitle}}
        <p class="notification-sender">
          sent by {{ alertSender }} @ {{ getLocalAlertTime(alertTime) }}
        </p>
      </template>
      <span v-html="alertDetail"></span>
    </b-modal>
    <HeaderControls  :namespace="namespace"/>
    <div class="fixed-top-bar-padding">
        <div class="container-fluid">
            <div class="deliverable-header">
                <h2>
                    <div class="media-call-icon pointer-default">
                        <img width="30px" src="@/csmworkflow/img/bell-module.svg"/>
                    </div>
                    Your Messages

                  	<template v-if="typeof userAlerts.data != 'undefined' && userAlerts.data.length > 0">
                  		<span class="d-inline-block float-right saved-views-area pt-15">
                  		<b-button variant="theme" class="btn btn-theme" @click.stop="makeAllAlertsRead">
                  		    Mark All as Read
                  		    <div role="status" v-show="runningTask" class="ml-2 spinner-border spinner-border-sm text-primary"><span class="sr-only">Marking...</span></div>
                  		</b-button>
                  		</span>
                    </template>
                </h2>
            </div>
        </div>

        <div class="container-fluid">
            <div class="global-alerts-status">
                <span v-if="typeof userAlerts.data != 'undefined' && userAlerts.data.length == 0"><h2>You have no notifications.</h2></span>
                <div class="alert-item clearfix">
                    <ul v-if="typeof userAlerts.data != 'undefined' && userAlerts.data.length > 0" class="list-unstyled">
                        <li
                        :key="'alert-'+index" 
                        v-for="(alert,index) in userAlerts.data" 
                        @click="setAlert(alert)" 
                        class="cursor-pointer"
                        :class="alert.status == 0 ? 'unread-notification' : 'read-notification'"
                        >
                            <div>
                                <span class="info-bubbles">
                                    <span class="initials badge badge-primary cursor-pointer">
                                        {{ alert.sender | textInitials }}
                                    </span>
                                </span>
                                <span @click.stop="confirmDeleteAlert=true; deleteAlertId = alert.id;" class="remove-alert cursor-pointer">
                                    <i class="fas fa-trash"></i>
                                </span>
                                <span v-if="alert.status == 0" class="alert-status">
                                    <i class="fas fa-circle" :class="alert.status == 0 ? 'text-primary' : 'text-primary'" v-b-tooltip.hover :title="alert.status == 0 ? 'Unread' : 'Read'"></i>
                                </span>
                                <p class="details">
                                    <span class="alert__name cursor-pointer fw-bold">{{ alert.title }}</span>
                                    <br>
                                    <span class="notification-sender">
                                        <span class="fw-bold">{{ alert.sender }} @ {{ getLocalAlertTime(alert.created_at) }}</span>
                                    </span>
                                    <br>
                                    <span class="note-message" v-html="processMessage(alert.message)"></span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="pagination-wrapper">
                    <pagination :data="userAlerts" @pagination-change-page="onChangePage" :limit="5"></pagination>
                </div>
            </div>
        </div>
    </div>

    <b-modal size="xl" hide-footer id="editDeliverableModal" 
        title="Edit Deliverable" class="modal-edit-deliverable" 
        @hide="editDeliverableModalHidden" @shown="pushRoute" @hidden="removeRoute">
        <EditModal 
        :allContacts="allContacts"  
        ref="refEditModal"
        :namespace="namespace" 
        :tabIndex="tabIndex" 
        />
    </b-modal>

    <b-modal size="lg" hide-footer id="editSocialModal" 
        title="Edit Social Deliverable" class="modal-edit-social-deliverable" 
        @hide="editSocialModalHidden" @shown="pushRoute" @hidden="removeRoute">
        <EditSocialModal ref="refEditSocialModal" :namespace="namespace" :tabIndex="tabIndex" />
    </b-modal>

    <b-modal size="xl" no-close-on-backdrop no-close-on-esc hide-footer id="editOrganicSocialMediaPlanModal"
        title="Edit Organic Social Media Plan" class="modal-edit-deliverable"
        @hide="editOrganicSocialModalPlanHidden" @shown="pushRoute" @hidden="removeRoute">
        <EditOrganicSocialMediaPlanModal ref="refEditOrganicSocialMediaPlanModal" :tabIndex="tabIndex"
            :namespace="namespace" />
    </b-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import toast from "../toast";
import CreateGlobalAlert from "../components/common/CreateGlobalAlert";
import HeaderControls from "../components/common/HeaderControls";
import EditModal from "../components/deliverables/EditModal";
import EditOrganicSocialMediaPlanModal from "../components/deliverables/EditOrganicSocialMediaPlanModal";
import EditSocialModal from "../components/deliverables/EditSocialModal.vue";

export default {
    data() {
        return {
        	namespace:"",
            alertTitle: '',
            alertDetail: '',
            runningTask: false,
            alertTime: '',
            alertSender: '',
            deleteAlertId: '',
            confirmDeleteAlert: false,
            tabIndex: 0,
        }
    },
    components: {
        HeaderControls,
        CreateGlobalAlert,
        EditModal,
        EditOrganicSocialMediaPlanModal,
        EditSocialModal,
    },
    computed: {
        ...mapGetters(['userAlerts','deliverableDetail','allContacts','taskHighlighted']),
        ...mapState({
            getDeliverableTemplateSlug(state, getters) {
                return getters['getDeliverableTemplateSlug']
            },
        }),
    },
    mounted() {
        // this.fetchUserAlerts();
        
        this.$root.$on("bv::modal::shown", (bvModal, modalId) => {
            if (modalId == 'editDeliverableModal') {
                if (this.taskHighlighted) {
                    let editModal = $("#editDeliverableModal");

                    this.$nextTick(() => {
                        setTimeout(() => {
                            let curEl = $(".task-fields .field-block.highlight");
                            const elOffset = curEl.offset();
                            editModal.scrollTop(elOffset.top - 0.4 * window.innerHeight);
                        }, 100);
                    });
                }
            }
        })
    },
    methods: {
        ...mapActions(['fetchUserAlerts', 'fetchProjectDeliverableById', 'getProjectNumberFromId']),
        ...mapMutations(['setDataLoading']),
        processMessage(message) {
            if (!message) return '';
            message = this.$options.filters.striphtml(message);
            if (message.length > 120) {
                return message.substring(0, 120) + '...';
            }
            return message;
        },
        onChangePage(data) {
            this.fetchUserAlerts(data);
        },
        deleteAlert(alertId) {
            this.$store.dispatch('deleteAlert', { alertId });
        },
        makeAllAlertsRead(alertId) {
            this.$store.dispatch('makeAllAlertsRead');
        },
        setAlert(alert) {
            this.alertTitle = alert.title;
            this.alertDetail = alert.message;
            this.alertSender = alert.sender;
            this.alertTime = alert.created_at;
            
            if(alert.status == 0) {
                this.$store.dispatch('makeAlertRead', {alert});
            }

            if (alert.alert_type == "deliverable" || alert.grouped_model == "deliverable") {
                let deliverableId = alert.model_id;
                if (alert.grouped_model == "deliverable") {
                    deliverableId = alert.grouped_model_id;
                }
                
                this.$store.dispatch("getDeliverableDetail", { deliverableId })
                .then(() => {
                    let currentTitle = document.title.match(/\(\d+\)\s/g);
                    if(!currentTitle) {
                        document.title = this.deliverableDetail.title;
                    } else {
                        document.title = currentTitle[0] + this.deliverableDetail.title;
                    }
                    const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
                    if (deliverableTemplateSlug == "media-call") {
                        // Only for media calls, contact is tab1, Chat is tab2
                        this.tabIndex = 1;
                    } else {
                        this.tabIndex = 0;
                    }
                    if (deliverableTemplateSlug == "social-media") {
                        this.$bvModal.show("editSocialModal");
                    } else if (deliverableTemplateSlug == "organic-social-media-plan") {
                        this.$bvModal.show("editOrganicSocialMediaPlanModal");
                    } else {
                        this.$bvModal.show("editDeliverableModal");
                    }
                });
            } else if (alert.alert_type == "project" || alert.grouped_model == "project") {
                let projectId = alert.model_id;
                if (alert.grouped_model == "project") {
                    projectId = alert.grouped_model_id;
                }
                this.goToProject(projectId);
            } else if (alert.alert_type == "task") {
                let taskId = alert.model_id;

                this.$store.dispatch("getDeliverableDetailByTask", { taskId })
                .then(() => {
                    let currentTitle = document.title.match(/\(\d+\)\s/g);
                    if(!currentTitle) {
                    document.title = this.deliverableDetail.title;
                    } else {
                    document.title = currentTitle[0] + this.deliverableDetail.title;
                    }
                    this.$store.dispatch("highlightTask", taskId);
                    this.$bvModal.show("editDeliverableModal");
                });
            } else {
                this.$bvModal.show("userGlobalAlertDetail");
            }
        },

        goToProject(projectId) {
            this.setDataLoading(true);
            this.getProjectNumberFromId(projectId).then((projectNumber) => {
                this.fetchProjectDeliverableById(projectNumber).then(() => {
                    this.setDataLoading(false);
                    const isNumber = !isNaN(Number(projectNumber));
                    if (isNumber) {
                        this.$router.push(`/project/${projectNumber}`);
                    } else {
                        toast.error('Invalid project.');
                    }
                });
            })
        },

        getLocalAlertTime(time) {
            const alertTime = this.$moment.utc(time);
            alertTime.local();
            return alertTime.format('MMM Do, hh:mm a');
        },

        // Deliverable modal related
        editDeliverableModalHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
        editSocialModalHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
		editOrganicSocialModalPlanHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
        pushRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') == -1) {
				history.pushState(
					{},
					null,
					'deliverable/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},
        removeRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') != -1) {
				this.$router.push({name: 'dashboard'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
				//this.$router.push(this.$router.currentRoute.path).catch(err => {console.log(err)});
			}
		},
    }
}
</script>

<style>

</style>